<bcb-generic-label [question]="question"></bcb-generic-label>
<mat-radio-group (change)="onChange($event)" [formControl]="formControl">
	<mat-radio-button
		*ngFor="let option of question.options"
		class="col-{{ 12 / question.options?.length }}"
		[value]="option.value"
		><span class="wrap-text">{{ option.label }}</span></mat-radio-button
	>
</mat-radio-group>
<mat-error class="radio-button-error" *ngIf="formControl?.invalid">{{
	errorMessage
}}</mat-error>
